import { message } from "antd";
import { useState } from "react";
import { api } from "../../../api";
import { Button } from "../../../externalComponents/tailwind/button";

export default function CancelRegisteredBatchDialog({
  isOpen,
  onClose,
  batchToCancel,
  user,
  onSuccess,
}) {
  const [cancelling, setCancelling] = useState(false);

  const handleConfirmCancel = async () => {
    if (!batchToCancel) {
      return;
    }

    setCancelling(true);
    try {
      await api.cancelRegisteredBatch({
        customerId: user.customerId,
        sendingBatchId: batchToCancel.sendingBatchId,
      });

      message.success("Campaign cancelled successfully!");
      onSuccess();
      onClose();
    } catch (error) {
      console.error("Error cancelling campaign:", error);
      message.error("Failed to cancel campaign. Please try again.");
    } finally {
      setCancelling(false);
    }
  };

  if (!isOpen || !batchToCancel) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-lg mx-4">
        <h3 className="text-lg font-bold mb-4">Cancel Campaign</h3>
        <p className="text-gray-700 mb-3">
          Are you sure you want to cancel this campaign?
        </p>
        <div className="bg-gray-50 rounded-lg p-4 mb-4">
          <p className="font-semibold text-sm text-gray-900 mb-2">
            Campaign details:
          </p>
          <ul className="space-y-1 text-sm text-gray-700">
            <li>
              <strong>Campaign:</strong> {batchToCancel.campaignName}
            </li>
            <li>
              <strong>Recipients:</strong> {batchToCancel.totalContacts}
            </li>
          </ul>
        </div>
        <div className="bg-red-50 rounded-lg p-4 mb-6 border border-red-200">
          <p className="font-semibold text-sm text-red-900 mb-2">
            ⚠️ Warning - This action is permanent:
          </p>
          <ul className="space-y-2 text-sm text-red-800">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                All <strong>{batchToCancel.totalContacts} scheduled
                messages</strong> will be permanently cancelled
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                The campaign status will change to <strong>"canceled"</strong>
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                <strong>This action cannot be undone</strong> - you will need to
                reschedule the campaign manually
              </span>
            </li>
          </ul>
        </div>
        <div className="flex justify-end gap-3">
          <Button
            color="secondaryButton"
            onClick={onClose}
            disabled={cancelling}
          >
            No, Keep Campaign
          </Button>
          <Button
            color="red"
            onClick={handleConfirmCancel}
            disabled={cancelling}
          >
            {cancelling ? "Cancelling..." : "Yes, Cancel Campaign"}
          </Button>
        </div>
      </div>
    </div>
  );
}
